import { ListItem } from "@testout/testout-commerce/models/ListItem";

class DateRange {
    private static _items: ListItem[];

    static initialize() {
        DateRange._items = [
            { name: "Today", value: 'TODAY', description: "Today from midnight" },
            { name: "Yesterday", value: 'YESTERDAY', description: "The previous 24 hour day" },
            { name: "Tomorrow", value: 'TOMORROW', description: "The next 24 hour day" },
            { name: "This Week", value: 'THISWEEK', description: "The current calendar week" },
            { name: "Last Week", value: 'LASTWEEK', description: "The previous calendar week" },
            { name: "Next Week", value: 'NEXTWEEK', description: "The next calendar week" },
            { name: "This Month", value: 'THISMONTH', description: "The current calendar month" },
            { name: "Last Month", value: 'LASTMONTH', description: "The previous calendar month" },
            { name: "Next Month", value: 'NEXTMONTH', description: "The next calendar month" },
            { name: "This Quarter", value: 'THISQUARTER', description: "The current quarter" },
            { name: "Last Quarter", value: 'LASTQUARTER', description: "The previous full quarter" },
            { name: "Next Quarter", value: 'NEXTQUARTER', description: "The next full quarter" },
            { name: "This Year", value: 'THISYEAR', description: "The current calendar year" },
            { name: "Last Year", value: 'LASTYEAR', description: "The previous calendar year" },
            { name: "Next Year", value: 'NEXTYEAR', description: "The next calendar year" },
            { name: "Year Before Last Year", value: "YEARBEFORELAST", description: "The calendar year before the previous calendar year" },
            { name: "This School Year", value: 'THISSCHOOLYEAR', description: "The current school year (July 1-Jun 30)" },
            { name: "Last School Year", value: 'LASTSCHOOLYEAR', description: "The previous school year (July 1-Jun 30)" },
            { name: "Next School Year", value: 'NEXTSCHOOLYEAR', description: "The next school year (July 1-Jun 30)" },
            { name: "Last 7 Days", value: 'LAST7DAYS', description: "The previous 7 days before today" },
            { name: "Next 7 Days", value: 'LAST7DAYS', description: "The next 7 days before today" },
            { name: "Last 14 Days", value: 'LAST14DAYS', description: "The previous 14 days before today" },
            { name: "Next 14 Days", value: 'LAST14DAYS', description: "The next 14 days before today" },
            { name: "Last 30 Days", value: 'LAST30DAYS', description: "The previous 30 days before today" },
            { name: "Next 30 Days", value: 'LAST30DAYS', description: "The next 30 days before today" },
            { name: "Last 60 Days", value: 'LAST60DAYS', description: "The previous 60 days before today" },
            { name: "Next 60 Days", value: 'LAST60DAYS', description: "The next 60 days before today" },
            { name: "Last 90 Days", value: 'LAST90DAYS', description: "The previous 90 days before today" },
            { name: "Next 90 Days", value: 'LAST90DAYS', description: "The next 90 days before today" },
            { name: "Last 180 Days", value: 'LAST180DAYS', description: "The previous 180 days before today" },
            { name: "Next 180 Days", value: 'LAST180DAYS', description: "The next 180 days before today" },
            { name: "Last 365 Days", value: 'LAST365DAYS', description: "The previous 365 days before today" },
            { name: "Next 365 Days", value: 'LAST365DAYS', description: "The next 365 days before today" }
        ];
    }

    static get items(): ListItem[] {
        return DateRange._items;
    }
};
DateRange.initialize();

export default DateRange;
